// src/pages/TotalLeave.js
import React, { useState, useEffect } from 'react';
import ProvidentLayout from '../../components/ProvidentLayout.jsx';
import { Row, Col, Dropdown, Button, Form, ButtonGroup } from 'react-bootstrap';
import { GiTakeMyMoney } from "react-icons/gi";
import './provident-fund.css';
import axios from 'axios'; // Import axios for API requests

const rowsPerPage = 10;

const ProvidentFund = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const userId = localStorage.getItem('userId'); // Get userId from session storage
    if (!userId) {
      console.error('User ID not found in session storage.');
      return;
    }

    setLoading(true);
    axios
      .get(`https://backend.ems.hiradentallab.com/api/pf/${userId}`) // Call the backend API with userId
      .then((response) => {
        console.log('Response:', response.data); // Check the structure of the response
        setData([response.data.data]); // Assuming response.data.data contains your data
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching PF details:', error);
        setLoading(false);
      });
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className='container-fluid'>
    <ProvidentLayout>
      <h1 className='provident-fund-title'>
        <GiTakeMyMoney className='provident-fund-icon' /> Provident Fund
      </h1>
      <hr />
      <div className='provident-fund-table-container'>
        <div className='entries-search-container' style={{ marginTop: 0 }}>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                  <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end search-container">
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-input"
                />
              </Form>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className='table table-striped provident-fund-table'>
            <thead className='provident-fund-table-header'>
              <tr>
                <th>SR</th>
                <th>Name</th>
                <th>Total Amount</th>
                <th>Available for Withdraw</th>
                <th>Withdraw's Available</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr><td colSpan="6" className="text-center">Loading...</td></tr>
  ) : (
    data.length ? (
      data.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.employeeName}</td> {/* Corrected Employee Name */}
          <td>{item.balance}</td> {/* Corrected Balance */}
          <td>{item.eightyPercent}</td> {/* Corrected Withdrawable Amount */}
          <td>{item.withdrawalsAvailable}</td> {/* Corrected Withdrawals Available */}
          <td><Button variant="primary" size="sm">Action</Button></td>
        </tr>
      ))
    ) : (
      <tr><td colSpan="6" className="text-center">No data Available Now</td></tr>
    )
  )}
</tbody>   <tfoot>
              <tr className='provident-fund-table-footer'>
                <td>Total</td>
                <td>-</td>
                <td>0</td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
          <div className="containerrrr">
            <Row className="custom-row">
              <Col xs={12} md={9} className="custom-col-left">
                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, data.length)} of {data.length} Entries
              </Col>
              <Col xs={12} md={3} className="custom-col-right">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage - 1);
                        }}
                      >
                        Previous
                      </a>
                    </li>
                    {pageRange().map(pageNumber => (
                      <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(pageNumber);
                          }}
                        >
                          {pageNumber}
                        </a>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                      <a
                        href="/#"
                        className="page-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange(currentPage + 1);
                        }}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </ProvidentLayout>
    </div>
  );
};


export default ProvidentFund;
